import Cryptonews from '../images/cryptonews.PNG'
import GQbit from '../images/gqbit.PNG'
import Budget from '../images/budget.PNG'
import TripMate from '../images/tripmate.PNG'
import { Link} from 'react-router-dom'


export const projectloop = [

  {url: TripMate,
    title: "Our TripMate ", 
    description: <p>
      Our TripMate solves the porblem of using different sites to gather information about hotels, attractions and restaurant.
      Here visiter can find any information regarding hotels, Restaurant and Attractions near by their place or anywhere else in the world.
      
    </p>,
    description2: <p>
   I comes very handy to traveller as the cany sort the places accroding to the ratings and choose the best places for them.
   I built this app using React js and redux for the state management, I used Rapid Api to fetch apis for these places. I used Google Map React to grab the co-ordinates and bounds then send that api to Rapi Api fetch data from according to the users demand.
  </p>,
    visit: "VISIT PAGE",  link: "https://ourtripmate.netlify.app/"



  },
    {url: GQbit,
      title: "GreenQbit ", 
      description: <p>
        Very fortunately I got to demonstrate the skill on that very  organization from where I learned it.
         I got to contribute while building the v2 of GreenQbit site.

      </p>,
      description2: <p>
        I built Services, Job and Enroll Now segment for the sites.
        Our Front End segment is fully based on React Js and I also created RestApi for the enrollment using Java - Spring Boot.
      </p>,
      visit: "VISIT PAGE",  link: "https://greenqbit.com/service"



    },
    
    {url: Cryptonews,
      title: "CRYPTONEWS ", 
      description: <p>As I am Crypto enthusiast myseld,  made this crypto news site using React, Redux Js toolkit & Rapid Api for APi endpoint. Here we can flawlessy check the latest price, marketcap, 24h volumes and any data regarding any cryptocurrency.
        It shows the ranking of the cryptocurrency with their marketcap and daily change on volume.
      </p>,
      description2:<p>
        Similary, we can catch up with very latest crypto news in this news section of this site
      </p>,
      visit: "VISIT PAGE", link: "https://cryptonewzz.netlify.app/"




    },
    {url: Budget,
      title: "Budget  Planner ", 
      description: <p>
        Budgetplanned is quite simple yet very handy budget planning app, that helps anyone to stay under budget.
         Here we can easily dedicate a budget then deduct the expense and search those expense.
          We can add all our expenses and keep the track of those expenses.
     
      </p>,
      description2: <p>
      After then end our cycle we can delete all your expenses and start a new budget cycle.

          
          I made this using React JS, Material UI and React Context for state management.
      </p>,
      visit: "VISIT PAGE",
      link: "https://budgetplanned.netlify.app/"


    }]
    export default projectloop;